<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />
			<!--<div class="row">
				<img src="../../assets/img/downloadbanner.jpg" style="width: 100%;"/>
			</div>-->
			<div class="dow-box" v-for="list in List">
				<div class="row">
					<div class="item" style="font-size: 16px;color: #666;">
						{{list.name}}
					</div>
					<div class="item" style="justify-content: flex-end;">
						<a :href="list.downUrl"> <Button >{{$t('lang.download')}}</Button></a>
					</div>
				</div>
			</div>
			
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				List:[]
			}
		},
		methods: {
			getDownloadList() {
				var self = this
				this.$api.api.listDownload().then(function(response) {
					if(response.data.code == 200) {
						self.List = response.data.data
					} else {
						self.$toast(response.data.msg);
					}

				})
			},
		},
		mounted() {
			this.getDownloadList();
		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		min-width: 1200px;
		margin: 0 auto;
		display: block;
		position: absolute;
		background: #fff;
		margin-top: 135px;
	}
	.center-body{
    	/*width: 1200px;*/
    	margin: 0 auto;
    }
    .dow-box{
    	margin-top: 5px;
    	padding: 25px 0;
    	border-bottom: 1px solid #d4d4d4;
    }
    
	
</style>